import React from "react"
import { render } from "react-dom"
import App from "/src/app"

render(<App />, document.getElementById("root"))
